import React from 'react'

/* doc
---
title: ModalContent
name: ModalContent
category: React - Bulma
---

A `ModalContent` component based on Bulma `.modal-content`. The content for modal

This should be used with `Modal`

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalContent>
      ...
    </ModalContent>
  </Modal>
```
*/
function ModalContent(props) {
  const { className, children, ...rest } = props

  const classes = [
    'bulma-modal-content',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default ModalContent
